<template>
  <div>
    <data-table-card
      :items="items"
      v-on:updateData="getStakeholders"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons v-if="userHasPerms(['Manage stakeholders'])">
        <b-button
          class="ml-2"
          :to="{ name: 'stakeholders-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:cards="slotProps">
        <router-link
          :to="{
            name: 'stakeholders-show',
            params: { id: slotProps.item.id },
          }"
          class="text-body pointer text-decoration-none"
        >
          <div class="row no-gutters">
            <div class="col-4 col-xl-3 p-1">
              <v-lazy-image
                v-if="slotProps.item.image"
                :src="slotProps.item.image"
                class="img-fluid"
              />

              <div
                class="
                  mt-1
                  py-1
                  font-weight-bold
                  text-center
                  font-size-11
                  text-white
                "
                :class="{'bg-success': slotProps.item.status == 'Active','bg-danger': slotProps.item.status == 'Obsolete','bg-warning': slotProps.item.status == 'Inactive'  }"
              >
                {{ slotProps.item.status }}
              </div>

            </div>
            <div class="col-8 col-xl-7 p-3">
              <h5 class="font-weight-bold">{{ slotProps.item.name }}</h5>
              <strong class="text-primary">{{ slotProps.item.category }} </strong> | {{ slotProps.item.current_tier }} <br>
              Engaged:
              <span class="text-danger" v-if="slotProps.item.engagements.length==0">Never</span>
              <span class="text-warning" v-if="slotProps.item.engagements.length>0">
                {{ moment(slotProps.item.engagements[0].engagement_date).fromNow() }}
              </span>

              <br>

              <small class="text-small text-black-50 nl2br" >{{ slotProps.item.physical_address }}</small>


            </div>
          </div>
        </router-link>

      </template>
    </data-table-card>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'stakeholders' })"
      :lazy="true"
    >
      <router-view
        @stakeholderCreated="stakeholderCreated()"
        @stakeholderUpdated="stakeholderUpdated()"
      ></router-view>
    </b-modal>
  </div>
</template>

<script>
import stakeholderRepo from "@/api/repos/stakeholderRepo";
import dataTableCard from "@/components/common/DataTableCard";

export default {
  components: {
    dataTableCard: dataTableCard,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
        { column: "category", label: "Category Asc", order: "asc" },
        { column: "category", label: "Category Desc", order: "desc" },

      ],
      filterOptions: [],
      filterStr:null,
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getStakeholders({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async getFilterData() {
      let { data } = await stakeholderRepo.createGetData();

      this.filterOptions.push({
        column: "group-heading",
        label: "category",
      });

      data.categories.forEach((p) => {
        this.filterOptions.push({
          column: "category",
          value: p,
          label: p,
        });
      });

      this.filterOptions.push({
        column: "group-heading",
        label: "current tier",
      });

      data.tiers.forEach((s) => {
        this.filterOptions.push({
          column: "current_tier",
          value: s,
          label: s,
        });
      });

      this.filterOptions.push({
        column: "group-heading",
        label: "status",
      });


        this.filterOptions.push({
          column: "status",
          value: "Active",
          label: "Active",
        });

        this.filterOptions.push({
          column: "status",
          value: "Inactive",
          label: "Inactive",
        });

        this.filterOptions.push({
          column: "status",
          value: "Obsolete",
          label: "Obsolete",
        });

    },

    async getStakeholders(e) {
        if(e.filters != null){
            this.filterStr = e.filters
        }else{
            this.filterStr = null
        }
      this.isLoad = true;
      try {
        let { data } = await stakeholderRepo.stakeholders(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          this.filterStr
        );

        this.items = data.stakeholders.data;
        this.totalRows = data.stakeholders.total;
        this.page = data.stakeholders.current_page;
        this.fromRow = data.stakeholders.from;
        this.toRow = data.stakeholders.to;
        this.lastPage = data.stakeholders.last_page;

        this.filterOptions = [];


        this.getFilterData();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    stakeholderCreated() {
      this.$bvToast.toast("Stakeholder Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getStakeholders({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    stakeholderUpdated() {
      this.$bvToast.toast("Stakeholder Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getStakeholders({
        sort: this.sort,
        filters: this.filterStr,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
